import { ActionsSheet } from '@/components/ui/actions-sheet'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Separator } from '@/components/ui/separator'
import { Demo, DsSection } from '../primitives'

export function ActionsSheetSection() {
  return (
    <DsSection
      id="actions-sheet"
      title="Actions sheet"
      consoleOnly
      intro="A detail page's action rail, for narrow screens. The trigger is hidden from lg up, where the rail itself belongs on the page — so render both: the rail inline under a max-lg:hidden wrapper, and the same rail inside this sheet."
    >
      <Demo label="Trigger — only visible below lg, so narrow this window to see it">
        <ActionsSheet label="Actions" title="Lead actions">
          <div className="flex flex-col gap-1">
            <Label className="text-muted-foreground text-xs">Assigned to</Label>
            <Select defaultValue="unassigned">
              <SelectTrigger className="w-full">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="unassigned">Unassigned</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Separator className="my-1" />
          <Button className="w-full justify-start">Create customer</Button>
          <Button variant="outline" className="w-full justify-start">
            Follow
          </Button>
          <Button variant="outline" className="w-full justify-start">
            Refresh from CAB
          </Button>
        </ActionsSheet>
      </Demo>
    </DsSection>
  )
}
